import {
    AnimationBaseController, IDragonBonesChildControllerConfiguration,
} from "@denishussar/html5-game-engine";
import { Inject } from "@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "@denishussar/html5-game-engine";
import { GameModel } from "../../Models/GameModel";

import { PlayerFrontController } from "./PlayerFrontController";
import { PlayerTypeConstants } from "../../Constants/PlayerTypeConstants";

export interface IPlayerContainerControllerOptions {
    statusType: 'win' | 'lose' | 'tie'
}

export class PlayerContainerController extends AnimationBaseController {
    $model: GameModel;


    public constructor(@Inject private _options: IPlayerContainerControllerOptions) {
        super("PlayerContainerController");
    }

    get _dbPlayer(): PlayerFrontController{
        return this.$childControllers.get < PlayerFrontController>('animation');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        const characterMap = {
            [PlayerTypeConstants.Kid]: 'girl_char',
            [PlayerTypeConstants.Woman]: 'woman_char',
            [PlayerTypeConstants.Man]: 'man_char',
            [PlayerTypeConstants.Oldman]: 'old_char',
        };

        return <IAnimationControllerConfiguration>{
            childControllers: {
                animation: <IDragonBonesChildControllerConfiguration>{
                    view: PlayerFrontController,
                    model: this.$model,
                    options: {
                        name: characterMap[this.$model.playerA.type]
                    },
                    x: -90
                },
            },
            modelWatch: {

            }
        };
    }

    protected onInitialize(): void {
        switch(this._options.statusType) {
            case 'win':
                this._dbPlayer.win();
                break;
            case 'lose':
                this._dbPlayer.lose();
                break;
            case 'tie':
                this._dbPlayer.tie();
                break;
        }
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

}

